/**
 * Phase 3I.4Q.2 — Defensive value coercion for React child rendering.
 *
 * Some activity rows from legacy code paths stored non-string values
 * in fields like `description` or `metadata.destination_url`. Rendering
 * an object directly crashes React with "Objects are not valid as a
 * React child". This helper is the single canonical coercion point —
 * every HQ activity-consuming component must route through it.
 */
export function asText(v) {
  if (v == null) return "";
  if (typeof v === "string") return v;
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  try { return JSON.stringify(v); } catch (_) { return String(v); }
}
